import dom from 'embo/utils/dom'
import vsync from 'embo/utils/vsync'
import animate from 'embo/utils/animate'
import SymfonyForm from './BaseSymfonyForm'


export default class NewsletterForm extends SymfonyForm {
  constructor() {
    const form = document.getElementById('newsletter-form')
    super(form, {spinner: false})
  }

  handleSuccess(response) {
    return super.handleSuccess(response).then(() => this.showSuccessMessage(response.message))
  }

  showSuccessMessage(message) {
    const container = dom.qs('.form-success', this.form)
    const el = dom.el('p', {className: 'form-success__message', text: message})
    return vsync.mutate(() => {
      el.style.display = 'none'
      container.append(el)
    }).then(() => animate(el, 'slideDown', {duration: 250}))
  }
}
